import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowLeft, ArrowRight, Quote } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";
import { TESTIMONIALS } from "./data";

export const Testimonials = () => {
  const [i, setI] = useState(0);
  const go = (d) => setI((v) => (v + d + TESTIMONIALS.length) % TESTIMONIALS.length);
  const t = TESTIMONIALS[i];

  return (
    <section data-testid="testimonials-section" className="relative overflow-hidden bg-[#0B1F4D] py-24 text-white sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
        <Reveal>
          <p className="mb-8 flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] text-white">
            <span className="h-px w-8 bg-white" /> Client words
          </p>
        </Reveal>
        <Quote className="mb-6 h-12 w-12" strokeWidth={2.5} />
        <div className="relative min-h-[260px] sm:min-h-[220px]">
          <AnimatePresence initial={false}>
            <motion.div
              key={i}
              initial={{ opacity: 0, x: 60 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -60, position: "absolute" }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
              className="inset-x-0 top-0"
            >
              <blockquote data-testid="testimonial-quote" className="max-w-5xl font-display text-3xl font-bold uppercase leading-[1.05] sm:text-5xl">
                {t.q}
              </blockquote>
              <p className="mt-8 font-mono text-sm uppercase tracking-[0.2em]">{t.n} — <span className="opacity-80">{t.r}</span></p>
            </motion.div>
          </AnimatePresence>
        </div>
        <div className="mt-10 flex items-center gap-3">
          <button data-testid="testimonial-prev" onClick={() => go(-1)} aria-label="Previous" className="grid h-14 w-14 place-items-center border-2 border-white transition-colors hover:bg-white hover:text-[#0B1F4D]"><ArrowLeft /></button>
          <button data-testid="testimonial-next" onClick={() => go(1)} aria-label="Next" className="grid h-14 w-14 place-items-center border-2 border-white transition-colors hover:bg-white hover:text-[#0B1F4D]"><ArrowRight /></button>
          <span className="ml-4 font-mono text-sm">0{i + 1} / 0{TESTIMONIALS.length}</span>
        </div>
      </div>
    </section>
  );
};
